import { CustomToaster } from "../reusable-components/Toasters/toaster"
import { logout } from "../utils";
// import { path } from "../constants/env";

/**
 * This is the universal API call wrapper for CYGNUS DATAHUB Frontend, use this to make any API calls.
 * @param {*} type : Type of request
 * @param {*} payload : Data to be sent in the API
 * @param {*} url : API url details
 * @param {*} show_message : flag to show message
 * @param {*} customized_success_message : Message to display in toaster for successful API call
 * @param {*} customized_failure_message : Message to display in toaster for failed API call
 * @param {*} customized_error_message : Message to display in toaster for error while making an API call
 * @param {*} isblob : Flag to return JSON or BLOB response
 * @returns : JSON or BLOB response
 */
export const makeCygnusApiCall = async ({
  type = "GET",
  payload = {},
  payload_is_file = false,
  url = "",
  show_message = false,
  customized_success_message = "Successful!",
  customized_failure_message = "Failed!",
  customized_error_message = "Error occured. Please contact support.",
  isblob = false,
  path = "/workflow",
  istax = false,
  default_message = false,
}) => {
  let response;
  try {
    const requestOptions = {
      method: type.toUpperCase(),
      headers: payload_is_file ? {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      } : {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    if (type.toUpperCase() !== "GET") {
      Object.assign(requestOptions, { "body": payload_is_file ? payload : JSON.stringify(payload) })
    }

    const uri = istax ? process.env.REACT_APP_TAX_URI : process.env.REACT_APP_BASE_URI;

    response = await fetch(`${uri}${path}${url}`, requestOptions)

    if (!response.ok) {
      if (response.status === 401) {
        // Handle unauthorized error
        logout();
        CustomToaster({ type: "error", customized_message: "Session ended , please login back", api_message: "" })
      } else {
        CustomToaster({ type: "error", customized_message: customized_failure_message, api_message: "" })
        throw new Error("Request failed.");
      }
    }
    const data = !isblob ? await response.json() : await response.blob();

    if (data.success === true || isblob) {
      if (show_message) {
        console.log(default_message ? data.message : customized_success_message)
        CustomToaster({ type: "success", customized_message: default_message ? data.message : customized_success_message, api_message: "" })
      }
      return data
    } else {
      CustomToaster({ type: "error", customized_message: default_message ? data.message : customized_failure_message, api_message: "" })
    }
  }
  catch (err) {
    console.log("Err: ", err)
    if (response.status !== 500) {
      CustomToaster({ type: "error", customized_message: customized_error_message, api_message: err })
    }
  }
}